import j from "aws-sdk/clients/s3";
import { createAxios as A } from "@dustess/iquery";
const { webGateway: v } = A({ baseURL: "", withCredentials: !0 });
var U;
((t) => {
  ((a) => {
    ((e) => {
      e[e.NULL_VALUE = 0] = "NULL_VALUE";
    })(a.NullValue || (a.NullValue = {}));
  })(t.protobuf || (t.protobuf = {}));
})(U || (U = {}));
class F {
  constructor() {
    this.config = (a, e) => {
      const i = e && e.header ? { ...e.header, "x-api-version": "v1.0.20240509153837070" } : { "x-api-version": "v1.0.20240509153837070" };
      return v({
        optionName: "mid-asset-api.midassetapi.StsService.Config",
        params: a,
        extra: {
          application_name: "mid-asset-api",
          service_name: "StsService",
          method_name: "Config",
          protobuf_version: "v1.0.20240509153837070",
          res_type_name: "ConfigResponse",
          ...e,
          header: i
        }
      });
    }, this.getToken = (a, e) => {
      const i = e && e.header ? { ...e.header, "x-api-version": "v1.0.20240509153837070" } : { "x-api-version": "v1.0.20240509153837070" };
      return v({
        optionName: "mid-asset-api.midassetapi.StsService.GetToken",
        params: a,
        extra: {
          application_name: "mid-asset-api",
          service_name: "StsService",
          method_name: "GetToken",
          protobuf_version: "v1.0.20240509153837070",
          res_type_name: "GetTokenResponse",
          ...e,
          header: i
        }
      });
    }, this.batchGetToken = (a, e) => {
      const i = e && e.header ? { ...e.header, "x-api-version": "v1.0.20240509153837070" } : { "x-api-version": "v1.0.20240509153837070" };
      return v({
        optionName: "mid-asset-api.midassetapi.StsService.BatchGetToken",
        params: a,
        extra: {
          application_name: "mid-asset-api",
          service_name: "StsService",
          method_name: "BatchGetToken",
          protobuf_version: "v1.0.20240509153837070",
          res_type_name: "BatchGetTokenResponse",
          ...e,
          header: i
        }
      });
    }, this.getTokenInner = (a, e) => {
      const i = e && e.header ? { ...e.header, "x-api-version": "v1.0.20240509153837070" } : { "x-api-version": "v1.0.20240509153837070" };
      return v({
        optionName: "mid-asset-api.midassetapi.StsService.GetTokenInner",
        params: a,
        extra: {
          application_name: "mid-asset-api",
          service_name: "StsService",
          method_name: "GetTokenInner",
          protobuf_version: "v1.0.20240509153837070",
          res_type_name: "GetTokenInnerResponse",
          ...e,
          header: i
        }
      });
    }, this.signURL = (a, e) => {
      const i = e && e.header ? { ...e.header, "x-api-version": "v1.0.20240509153837070" } : { "x-api-version": "v1.0.20240509153837070" };
      return v({
        optionName: "mid-asset-api.midassetapi.StsService.SignURL",
        params: a,
        extra: {
          application_name: "mid-asset-api",
          service_name: "StsService",
          method_name: "SignURL",
          protobuf_version: "v1.0.20240509153837070",
          res_type_name: "SignURLResponse",
          ...e,
          header: i
        }
      });
    }, this.putObjectCallBack = (a, e) => {
      const i = e && e.header ? { ...e.header, "x-api-version": "v1.0.20240509153837070" } : { "x-api-version": "v1.0.20240509153837070" };
      return v({
        optionName: "mid-asset-api.midassetapi.StsService.PutObjectCallBack",
        params: a,
        extra: {
          application_name: "mid-asset-api",
          service_name: "StsService",
          method_name: "PutObjectCallBack",
          protobuf_version: "v1.0.20240509153837070",
          res_type_name: "PutObjectCallBackResponse",
          ...e,
          header: i
        }
      });
    }, this.putObjectCallBackWithInfo = (a, e) => {
      const i = e && e.header ? { ...e.header, "x-api-version": "v1.0.20240509153837070" } : { "x-api-version": "v1.0.20240509153837070" };
      return v({
        optionName: "mid-asset-api.midassetapi.StsService.PutObjectCallBackWithInfo",
        params: a,
        extra: {
          application_name: "mid-asset-api",
          service_name: "StsService",
          method_name: "PutObjectCallBackWithInfo",
          protobuf_version: "v1.0.20240509153837070",
          res_type_name: "PutObjectCallBackWithInfoResponse",
          ...e,
          header: i
        }
      });
    };
  }
}
const k = new F();
async function I(t) {
  const { accessKeyId: a, accessKeySecret: e, Endpoint: i, Region: n, sessionToken: o } = t;
  return new j({
    accessKeyId: a,
    secretAccessKey: e,
    sessionToken: o,
    endpoint: i,
    region: n,
    apiVersion: "2006-03-01"
  });
}
const B = (t, a, e, i) => new Promise((n, o) => {
  try {
    const { Bucket: p, Key: s, isMediaURL: c, videoSuffixType: l, Host: m, acl: d, infoConfig: r, system: u } = i, f = {
      Bucket: p,
      Key: s,
      Body: t,
      ContentType: t.type,
      ContentDisposition: "filename*=UTF-8''" + encodeURIComponent(`${t.name}`)
    }, w = {
      partSize: 5 * 1024 * 1024,
      queueSize: 1
    };
    e.upload(f, w, async function(x, _) {
      var S, h;
      if (x)
        o(x);
      else {
        let P, y = {};
        const T = m + "/" + s;
        if (c) {
          const g = s.split(".");
          P = g[0] + l + g[1], y.mediaURL = m + "/" + P;
        }
        if (y.url = T, y.key = s, d === "privateReadAndWrite") {
          const g = await k.signURL({ urls: [T] }, r.extra);
          (g == null ? void 0 : g.code) === "0" && (y.url = ((h = (S = g.data) == null ? void 0 : S.url) == null ? void 0 : h[T]) || T, y.cosURL = T);
        }
        u || await k.putObjectCallBack({ fileIds: [r.fileId] }, r.extra), n(y);
      }
    }).on("httpUploadProgress", function(x) {
      const _ = Math.round(x.loaded / x.total * 100);
      a.progress(_);
    });
  } catch (p) {
    o(p);
  }
});
class N {
  constructor(a) {
    this.AmazonClient = null, this.initClientConfig = a;
  }
  // 初始化客户端
  async init() {
    this.AmazonClient = await I(this.initClientConfig);
  }
  // 分片上传
  async multipartUpload(a, e) {
    return await this.init(), B(a, e, this.AmazonClient, this.initClientConfig);
  }
}
const z = async (t, a) => {
  try {
    const { config: e } = a, i = new N({ ...e }), n = await i.multipartUpload(t, {
      progress: (o) => {
        a.progress({
          msg: "上传中...",
          data: {
            progress: o
          },
          file: t,
          AmazonClient: i
        });
      }
    });
    a.success({
      code: 0,
      msg: "上传成功",
      data: n,
      file: t
    });
  } catch (e) {
    a.fail({
      code: 500321,
      msg: "上传失败",
      data: e,
      file: t
    });
  }
};
class O {
  constructor() {
    this.zip = (a, e) => {
      const i = e && e.header ? { ...e.header, "x-api-version": "v1.0.20240509163651557" } : { "x-api-version": "v1.0.20240509163651557" };
      return v({
        optionName: "mid-asset-api.midassetapi.MediaProcessingService.Zip",
        params: a,
        extra: {
          application_name: "mid-asset-api",
          service_name: "MediaProcessingService",
          method_name: "Zip",
          protobuf_version: "v1.0.20240509163651557",
          res_type_name: "ZipResponse",
          ...e,
          header: i
        }
      });
    }, this.mediaMeta = (a, e) => {
      const i = e && e.header ? { ...e.header, "x-api-version": "v1.0.20240509163651557" } : { "x-api-version": "v1.0.20240509163651557" };
      return v({
        optionName: "mid-asset-api.midassetapi.MediaProcessingService.MediaMeta",
        params: a,
        extra: {
          application_name: "mid-asset-api",
          service_name: "MediaProcessingService",
          method_name: "MediaMeta",
          protobuf_version: "v1.0.20240509163651557",
          res_type_name: "MediaMetaResponse",
          ...e,
          header: i
        }
      });
    }, this.media2Image = (a, e) => {
      const i = e && e.header ? { ...e.header, "x-api-version": "v1.0.20240509163651557" } : { "x-api-version": "v1.0.20240509163651557" };
      return v({
        optionName: "mid-asset-api.midassetapi.MediaProcessingService.Media2Image",
        params: a,
        extra: {
          application_name: "mid-asset-api",
          service_name: "MediaProcessingService",
          method_name: "Media2Image",
          protobuf_version: "v1.0.20240509163651557",
          res_type_name: "Media2ImageResponse",
          ...e,
          header: i
        }
      });
    }, this.imageProcessing = (a, e) => {
      const i = e && e.header ? { ...e.header, "x-api-version": "v1.0.20240509163651557" } : { "x-api-version": "v1.0.20240509163651557" };
      return v({
        optionName: "mid-asset-api.midassetapi.MediaProcessingService.ImageProcessing",
        params: a,
        extra: {
          application_name: "mid-asset-api",
          service_name: "MediaProcessingService",
          method_name: "ImageProcessing",
          protobuf_version: "v1.0.20240509163651557",
          res_type_name: "ImageProcessingResponse",
          ...e,
          header: i
        }
      });
    }, this.reportFileRel = (a, e) => {
      const i = e && e.header ? { ...e.header, "x-api-version": "v1.0.20240509163651557" } : { "x-api-version": "v1.0.20240509163651557" };
      return v({
        optionName: "mid-asset-api.midassetapi.MediaProcessingService.ReportFileRel",
        params: a,
        extra: {
          application_name: "mid-asset-api",
          service_name: "MediaProcessingService",
          method_name: "ReportFileRel",
          protobuf_version: "v1.0.20240509163651557",
          res_type_name: "ReportFileRelResponse",
          ...e,
          header: i
        }
      });
    };
  }
}
const b = new O();
class E {
  constructor(a) {
    this.convertParam = a;
  }
  async media2Image() {
    const { service: a, extra: e } = this.convertParam;
    return await b.media2Image(a, e);
  }
}
const ra = async (t) => {
  try {
    return await new E(t).media2Image();
  } catch (a) {
    return console.error("icloud convert file:", a.message), a;
  }
};
function G() {
  return /wxwork/i.test(window.navigator.userAgent);
}
function W() {
  return /Android|Windows Phone|webOS|iPhone|iPod|BlackBerry/i.test(window.navigator.userAgent);
}
function D() {
  return window.wx;
}
function V() {
  return /Android|BlackBerry/i.test(window.navigator.userAgent);
}
const C = class C {
  constructor(a) {
    this.metaParam = a;
  }
  /**
   * 附件预览
   * @param meta 
   * @returns 
   */
  async attachmentFileType(a) {
    var l, m;
    const { path: e, dstType: i, mediaMeta: { url: n }, extra: o, reject: p, resolve: s } = a, c = n || e;
    try {
      const d = {
        action: "preview",
        url: c,
        data: JSON.stringify({
          dstType: i || "html",
          public: !0
        })
      }, r = await b.imageProcessing(d, o);
      return (r == null ? void 0 : r.code) === "0" ? (window.open((l = r == null ? void 0 : r.data) == null ? void 0 : l.url), s({
        cloudLog: `apiType: preview | attachment | window.open(${(m = r == null ? void 0 : r.data) == null ? void 0 : m.url})`,
        data: r.data
      })) : p({
        cloudLog: "apiType: preview | attachment | code !== 0",
        data: r
      });
    } catch (d) {
      return p({
        cloudLog: "apiType: preview | error",
        data: d
      });
    }
  }
  /**
   * 文件预览
   * @param meta 
   * @returns 
   */
  async preview(a) {
    const { path: e, mediaMeta: { fileExt: i, url: n }, resolve: o } = a, p = ["mp4", "jpeg", "jpg", "png", "gif", "webp", "wma", "avi", "wmv", "mov", "mp3", "m4a", "wma", "flac"], s = n || e;
    if (i && n) {
      const c = i.toLowerCase() || n.substring(n.lastIndexOf(".") + 1).toLowerCase();
      if (p.includes(c))
        return window.open(s), o({
          cloudLog: `apiType: preview | window.open(${s})`,
          data: s
        });
      await this.attachmentFileType(a);
    }
  }
  /**
   * 文件下载
   * @param meta 
   * @returns 
   */
  async download(a) {
    var u, f;
    const { path: e, fileConfig: i, mediaMeta: n, extra: o, reject: p, resolve: s } = a, { fileName: c, url: l, disposition: m } = n, d = (i == null ? void 0 : i.fileName) || decodeURIComponent(c || ""), r = l || e;
    if (m && m.includes("attachment"))
      return L(r, d), s({
        cloudLog: `apiType: download | content-disposition携带attachment | <a>(${r})</a>`,
        data: r
      });
    try {
      const w = {
        action: "download",
        url: r,
        data: JSON.stringify({
          filename: d
        })
      }, x = await b.imageProcessing(w, o);
      return (x == null ? void 0 : x.code) === "0" ? (x.data && x.data.url && L((u = x == null ? void 0 : x.data) == null ? void 0 : u.url, d), s({
        cloudLog: `apiType: download | content-disposition不携带attachment | <a>(${(f = x == null ? void 0 : x.data) == null ? void 0 : f.url})</a>`,
        data: x.data
      })) : p({
        cloudLog: "apiType: download apicode!== 0",
        data: x
      });
    } catch (w) {
      return p({
        cloudLog: "apiType: download error",
        data: w
      });
    }
  }
  /**
   * 处理浏览器文件下载以及预览
   * @param meta 
   * @returns 
   */
  async browserPlatform(a) {
    var m, d;
    const { apiType: e, custom: i, mediaMeta: { acl: n }, path: o, extra: p, resolve: s, reject: c } = a, { mediaMeta: l } = a;
    if (e === "download" && await this.download(a), e === "preview" && n && n === "privateReadAndWrite") {
      const r = {
        service: {
          urls: [o]
        },
        extra: p
      }, u = await k.signURL(r.service, r.extra);
      return (u == null ? void 0 : u.code) === "0" ? (l.url = ((d = (m = u.data) == null ? void 0 : m.url) == null ? void 0 : d[o]) || "", i ? s({
        cloudLog: `custom:${i}, apiType: preview | acl:privateReadAndWrite`,
        data: u.data
      }) : (window.open(l.url), s({
        cloudLog: `'apiType: preview | acl: privateReadAndWrite' | window.open(${l.url})`,
        data: l.url
      }))) : c({
        cloudLog: "apiType: preview | acl: privateReadAndWrite",
        data: u
      });
    }
    if (e === "preview" && i)
      return s({
        cloudLog: "apiType: preview | acl: privateReadAndWrite",
        data: l
      });
    await this.preview(a);
  }
  /**
   * 处理企微移动文件下载以及预览
   * @param meta 
   * @returns 
   */
  async mobilePlatform(a) {
    const { mobile: e, apiType: i, resolve: n } = a;
    if (e && i === "preview")
      return n({
        cloudLog: "apiType: preview | mobile"
      });
    const { path: o, mediaMeta: { size: p, url: s, fileName: c }, wxVector: l, fileConfig: m, reject: d } = a;
    try {
      const r = (m == null ? void 0 : m.fileName) || c, u = {
        url: s || o,
        name: r,
        size: p,
        wxVector: l
      };
      V() && (u.name = K(r));
      const f = await this.usePreviewFile(u);
      return n({
        cloudLog: "apiType: preview | wx.invoke",
        data: f
      });
    } catch (r) {
      return d({
        cloudLog: "apiType: preview | wx.invoke | error",
        data: r
      });
    }
  }
  /**
   * 企微API
   * @param meta 
   * @returns 
   */
  usePreviewFile(a) {
    return new Promise((e, i) => {
      const { url: n, name: o, size: p, wxVector: s } = a;
      (s ? parent.window.wx : window.wx).invoke("previewFile", {
        url: n,
        name: o,
        size: Number(p)
      }, function(l) {
        l.err_msg === "previewFile:ok" ? e(l) : i(l);
      });
    });
  }
  /**
   * 运行终端
   * @param meta 
   * @returns 
   */
  async runtimeTerminal(a) {
    G() && W() && D() ? await this.mobilePlatform(a) : await this.browserPlatform(a);
  }
  /**
   * 
   * @param {iDownloadPreviewTask} metaParam 
   * @param {object.path} metaParam.service - 接口参数
   * @param metaParam.extra - 接口扩展参数
   * @param metaParam.executiveType - 表明1: download|2: preview
   * @param metaParam.mobile - 自定义（移动端自定义）
   * @param metaParam.custom - 自定义（PC端自定义）
   * @returns 
   */
  downloadPreviewFile() {
    return new Promise(async (a, e) => {
      const { service: i, executiveType: n, custom: o, mobile: p, previewConfig: s, fileConfig: c, extra: l } = this.metaParam, m = C.executiveMap[n], d = await b.mediaMeta(i, l);
      if ((d == null ? void 0 : d.code) === "0") {
        const r = {
          apiType: m,
          mediaMeta: d.data || {},
          extra: l,
          path: i.path,
          custom: o,
          // 是否自定义（非移动端）
          mobile: p,
          // 是否使用企微api（移动端自定义）
          wxVector: (c == null ? void 0 : c.wxVector) || !1,
          resolve: a,
          reject: e
        };
        m === "preview" && (r.dstType = (s == null ? void 0 : s.dsType) || "html"), await this.runtimeTerminal(r);
      } else
        e(d);
    });
  }
};
C.executiveMap = {
  1: "download",
  2: "preview"
};
let M = C;
const ca = async (t) => {
  try {
    return await new M(t).downloadPreviewFile();
  } catch (a) {
    return console.error("icloud download preview file:", a), a;
  }
}, K = (t) => {
  const e = t.length;
  let i = 0, n = t;
  if (28 < e) {
    i = e - 28;
    const o = 28 / 2 + i + 3;
    n = t.replace(t.substring(28 / 2, o), "...");
  }
  return n;
}, L = (t, a) => {
  let e = document.createElement("a");
  const i = new MouseEvent("click");
  e.href = t, e.download = a || "", e.dispatchEvent(i), e = null;
};
class $ {
  constructor(a) {
    this.metaParam = a;
  }
  async mediaMeta() {
    const { service: a, extra: e } = this.metaParam;
    return await b.mediaMeta(a, e);
  }
}
const la = async (t) => {
  try {
    return await new $(t).mediaMeta();
  } catch (a) {
    return console.error("icloud meta file:", a.message), a;
  }
};
class q {
  constructor(a) {
    this.metaParam = a;
  }
  async imageProcessing() {
    const { service: a, extra: e } = this.metaParam, i = {
      action: a.action,
      url: a.url,
      data: JSON.stringify(a.data)
    };
    return await b.imageProcessing(i, e);
  }
}
const da = async (t) => {
  try {
    return await new q(t).imageProcessing();
  } catch (a) {
    return console.error("icloud processing file:", a.message), a;
  }
};
function H(t) {
  const a = ["mp4", "mp3", "m4v"];
  let e = "";
  typeof t == "string" ? e = t : e = t.name;
  const i = e.split("."), n = i[i.length - 1].toLowerCase();
  return a.includes(n);
}
class J {
  constructor(a) {
    this.disposeParam = a, this.fileMeta = {};
  }
  metaConfig(a) {
    const { file: e, service: i, extra: n, system: o, serviceSystem: p } = a;
    this.fileMeta = e.file || e;
    const s = { ...i, ...p };
    return {
      serviceMeta: {
        ...o ? s : i,
        fileType: this.fileMeta.type === "" ? "application/octet-stream" : this.fileMeta.type,
        originalName: this.fileMeta.name,
        fileSize: this.fileMeta.size
      },
      extraMeta: {
        baseURL: n == null ? void 0 : n.baseURL,
        header: {
          ...n == null ? void 0 : n.header
        }
      },
      system: !!o
    };
  }
  metaUploadConfig(a, e) {
    const { data: { tokenMeta: i, bucketMeta: n, videoTransIsHigh: o, fileId: p } } = e, s = {
      videoSuffixType: "",
      isMediaURL: !1
    };
    return H(this.fileMeta) && (s.videoSuffixType = "_final.", o && (s.videoSuffixType = "_high."), s.isMediaURL = !0), {
      accessKeyId: i.tmpSecretId,
      accessKeySecret: i.tmpSecretKey,
      sessionToken: i.token,
      expiredTime: i.expirationTime,
      Bucket: n.bucket,
      Key: i.path,
      Endpoint: n.endpoint,
      Region: n.region,
      Host: n.host,
      ...s,
      system: a.system,
      acl: this.disposeParam.service.acl,
      infoConfig: {
        fileId: p,
        extra: {
          ...a.extraMeta
        }
      }
    };
  }
  async cloudUpload() {
    const { methods: a, system: e } = this.disposeParam, i = await this.metaConfig(this.disposeParam), n = e ? await this.getTokenInner(i) : await this.getToken(i);
    if ((n == null ? void 0 : n.code) !== "0")
      return a.fail(n);
    const o = await this.metaUploadConfig(i, n);
    z(this.fileMeta, {
      config: o,
      fail: (p) => {
        a.fail(p);
      },
      success: (p) => {
        a.success(p);
      },
      progress: (p) => {
        a.progress(p);
      }
    });
  }
  async getToken(a) {
    return await k.getToken(a.serviceMeta, a.extraMeta);
  }
  async getTokenInner(a) {
    return await k.getTokenInner(a.serviceMeta, a.extraMeta);
  }
}
const ma = async (t) => {
  try {
    await new J(t).cloudUpload();
  } catch (a) {
    console.error("icloud upload file:", a.message);
  }
};
class Z {
  constructor(a) {
    this.authParams = a;
  }
  async signURL() {
    const { service: a, extra: e } = this.authParams;
    return await k.signURL(a, e);
  }
}
const xa = async (t) => {
  try {
    return await new Z(t).signURL();
  } catch (a) {
    return console.error("icloud authorization file:", a.message), a;
  }
}, Q = {
  "0.001": "application/x-001",
  "0.323": "text/h323",
  "0.907": "drawing/907",
  ".acp": "audio/x-mei-aac",
  ".aif": "audio/aiff",
  ".aiff": "audio/aiff",
  ".asa": "text/asa",
  ".asp": "text/asp",
  ".au": "audio/basic",
  ".awf": "application/vnd.adobe.workflow",
  ".bmp": "application/x-bmp",
  ".c4t": "application/x-c4t",
  ".cal": "application/x-cals",
  ".cdf": "application/x-netcdf",
  ".cel": "application/x-cel",
  ".cg4": "application/x-g4",
  ".cit": "application/x-cit",
  ".cml": "text/xml",
  ".cmx": "application/x-cmx",
  ".crl": "application/pkix-crl",
  ".csi": "application/x-csi",
  ".cut": "application/x-cut",
  ".dbm": "application/x-dbm",
  ".dcd": "text/xml",
  ".der": "application/x-x509-ca-cert",
  ".dib": "application/x-dib",
  ".doc": "application/msword",
  ".drw": "application/x-drw",
  ".dwf": "Model/vnd.dwf",
  ".dwg": "application/x-dwg",
  ".dxf": "application/x-dxf",
  ".emf": "application/x-emf",
  ".ent": "text/xml",
  ".eps": "application/x-ps",
  ".etd": "application/x-ebx",
  ".fax": "image/fax",
  ".fif": "application/fractals",
  ".frm": "application/x-frm",
  ".gbr": "application/x-gbr",
  ".gif": "image/gif",
  ".gp4": "application/x-gp4",
  ".hmr": "application/x-hmr",
  ".hpl": "application/x-hpl",
  ".hrf": "application/x-hrf",
  ".htc": "text/x-component",
  ".html": "text/html",
  ".htx": "text/html",
  ".ico": "image/x-icon",
  ".iff": "application/x-iff",
  ".igs": "application/x-igs",
  ".img": "application/x-img",
  ".isp": "application/x-internet-signup",
  ".java": "java/*",
  ".jpe": "image/jpeg",
  ".jpeg": "image/jpeg",
  ".jpg": "application/x-jpg",
  ".jsp": "text/html",
  ".lar": "application/x-laplayer-reg",
  ".lavs": "audio/x-liquid-secure",
  ".lmsff": "audio/x-la-lms",
  ".ltr": "application/x-ltr",
  ".m2v": "video/x-mpeg",
  ".m4e": "video/mpeg4",
  ".man": "application/x-troff-man",
  ".mdb": "application/msaccess",
  ".mfp": "application/x-shockwave-flash",
  ".mhtml": "message/rfc822",
  ".mid": "audio/mid",
  ".mil": "application/x-mil",
  ".mnd": "audio/x-musicnet-download",
  ".mocha": "application/x-javascript",
  ".mp1": "audio/mp1",
  ".mp2v": "video/mpeg",
  ".mp4": "video/mpeg4",
  ".mpd": "application/vnd.ms-project",
  ".mpeg": "video/mpg",
  ".mpga": "audio/rn-mpeg",
  ".mps": "video/x-mpeg",
  ".mpv": "video/mpg",
  ".mpw": "application/vnd.ms-project",
  ".mtx": "text/xml",
  ".net": "image/pnetvue",
  ".nws": "message/rfc822",
  ".out": "application/x-out",
  ".p12": "application/x-pkcs12",
  ".p7c": "application/pkcs7-mime",
  ".p7r": "application/x-pkcs7-certreqresp",
  ".pc5": "application/x-pc5",
  ".pcl": "application/x-pcl",
  ".pdf": "application/pdf",
  ".pdx": "application/vnd.adobe.pdx",
  ".pgl": "application/x-pgl",
  ".pko": "application/vnd.ms-pki.pko",
  ".plg": "text/html",
  ".plt": "application/x-plt",
  ".png": "application/x-png",
  ".ppa": "application/vnd.ms-powerpoint",
  ".pps": "application/vnd.ms-powerpoint",
  ".ppt": "application/x-ppt",
  ".prf": "application/pics-rules",
  ".prt": "application/x-prt",
  ".ps": "application/postscript",
  ".pwz": "application/vnd.ms-powerpoint",
  ".ra": "audio/vnd.rn-realaudio",
  ".ras": "application/x-ras",
  ".rdf": "text/xml",
  ".red": "application/x-red",
  ".rjs": "application/vnd.rn-realsystem-rjs",
  ".rlc": "application/x-rlc",
  ".rm": "application/vnd.rn-realmedia",
  ".rmi": "audio/mid",
  ".rmm": "audio/x-pn-realaudio",
  ".rms": "application/vnd.rn-realmedia-secure",
  ".rmx": "application/vnd.rn-realsystem-rmx",
  ".rp": "image/vnd.rn-realpix",
  ".rsml": "application/vnd.rn-rsml",
  ".rtf": "application/msword",
  ".rv": "video/vnd.rn-realvideo",
  ".sat": "application/x-sat",
  ".sdw": "application/x-sdw",
  ".slb": "application/x-slb",
  ".slk": "drawing/x-slk",
  ".smil": "application/smil",
  ".snd": "audio/basic",
  ".sor": "text/plain",
  ".spl": "application/futuresplash",
  ".ssm": "application/streamingmedia",
  ".stl": "application/vnd.ms-pki.stl",
  ".sty": "application/x-sty",
  ".swf": "application/x-shockwave-flash",
  ".tg4": "application/x-tg4",
  ".tif": "image/tiff",
  ".tiff": "image/tiff",
  ".top": "drawing/x-top",
  ".tsd": "text/xml",
  ".uin": "application/x-icq",
  ".vcf": "text/x-vcard",
  ".vdx": "application/vnd.visio",
  ".vpg": "application/x-vpeg005",
  ".vsd": "application/x-vsd",
  ".vst": "application/vnd.visio",
  ".vsw": "application/vnd.visio",
  ".vtx": "application/vnd.visio",
  ".wav": "audio/wav",
  ".wb1": "application/x-wb1",
  ".wb3": "application/x-wb3",
  ".wiz": "application/msword",
  ".wk4": "application/x-wk4",
  ".wks": "application/x-wks",
  ".wma": "audio/x-ms-wma",
  ".wmf": "application/x-wmf",
  ".wmv": "video/x-ms-wmv",
  ".wmz": "application/x-ms-wmz",
  ".wpd": "application/x-wpd",
  ".wpl": "application/vnd.ms-wpl",
  ".wr1": "application/x-wr1",
  ".wrk": "application/x-wrk",
  ".ws2": "application/x-ws",
  ".wsdl": "text/xml",
  ".xdp": "application/vnd.adobe.xdp",
  ".xfd": "application/vnd.adobe.xfd",
  ".xhtml": "text/html",
  ".xls": "application/x-xls",
  ".xml": "text/xml",
  ".xq": "text/xml",
  ".xquery": "text/xml",
  ".xsl": "text/xml",
  ".xwd": "application/x-xwd",
  ".sis": "application/vnd.symbian.install",
  ".x_t": "application/x-x_t",
  ".apk": "application/vnd.android.package-archive",
  "0.301": "application/x-301",
  "0.906": "application/x-906",
  ".a11": "application/x-a11",
  ".ai": "application/postscript",
  ".aifc": "audio/aiff",
  ".anv": "application/x-anv",
  ".asf": "video/x-ms-asf",
  ".asx": "video/x-ms-asf",
  ".avi": "video/avi",
  ".biz": "text/xml",
  ".bot": "application/x-bot",
  ".c90": "application/x-c90",
  ".cat": "application/vnd.ms-pki.seccat",
  ".cdr": "application/x-cdr",
  ".cer": "application/x-x509-ca-cert",
  ".cgm": "application/x-cgm",
  ".class": "java/*",
  ".cmp": "application/x-cmp",
  ".cot": "application/x-cot",
  ".crt": "application/x-x509-ca-cert",
  ".css": "text/css",
  ".dbf": "application/x-dbf",
  ".dbx": "application/x-dbx",
  ".dcx": "application/x-dcx",
  ".dgn": "application/x-dgn",
  ".dll": "application/x-msdownload",
  ".dot": "application/msword",
  ".dtd": "text/xml",
  ".dwf": "application/x-dwf",
  ".dxb": "application/x-dxb",
  ".edn": "application/vnd.adobe.edn",
  ".eml": "message/rfc822",
  ".epi": "application/x-epi",
  ".eps": "application/postscript",
  ".exe": "application/x-msdownload",
  ".fdf": "application/vnd.fdf",
  ".fo": "text/xml",
  ".g4": "application/x-g4",
  ".tif": "image/tiff",
  ".gl2": "application/x-gl2",
  ".hgl": "application/x-hgl",
  ".hpg": "application/x-hpgl",
  ".hqx": "application/mac-binhex40",
  ".hta": "application/hta",
  ".htm": "text/html",
  ".htt": "text/webviewhtml",
  ".icb": "application/x-icb",
  ".ico": "application/x-ico",
  ".ig4": "application/x-g4",
  ".iii": "application/x-iphone",
  ".ins": "application/x-internet-signup",
  ".IVF": "video/x-ivf",
  ".jfif": "image/jpeg",
  ".jpe": "application/x-jpe",
  ".jpg": "image/jpeg",
  ".js": "application/x-javascript",
  ".la1": "audio/x-liquid-file",
  ".latex": "application/x-latex",
  ".lbm": "application/x-lbm",
  ".ls": "application/x-javascript",
  ".m1v": "video/x-mpeg",
  ".m3u": "audio/mpegurl",
  ".mac": "application/x-mac",
  ".math": "text/xml",
  ".mdb": "application/x-mdb",
  ".mht": "message/rfc822",
  ".mi": "application/x-mi",
  ".midi": "audio/mid",
  ".mml": "text/xml",
  ".mns": "audio/x-musicnet-stream",
  ".movie": "video/x-sgi-movie",
  ".mp2": "audio/mp2",
  ".mp3": "audio/mp3",
  ".mpa": "video/x-mpg",
  ".mpe": "video/x-mpeg",
  ".mpg": "video/mpg",
  ".mpp": "application/vnd.ms-project",
  ".mpt": "application/vnd.ms-project",
  ".mpv2": "video/mpeg",
  ".mpx": "application/vnd.ms-project",
  ".mxp": "application/x-mmxp",
  ".nrf": "application/x-nrf",
  ".odc": "text/x-ms-odc",
  ".p10": "application/pkcs10",
  ".p7b": "application/x-pkcs7-certificates",
  ".p7m": "application/pkcs7-mime",
  ".p7s": "application/pkcs7-signature",
  ".pci": "application/x-pci",
  ".pcx": "application/x-pcx",
  ".pdf": "application/pdf",
  ".pfx": "application/x-pkcs12",
  ".pic": "application/x-pic",
  ".pl": "application/x-perl",
  ".pls": "audio/scpls",
  ".png": "image/png",
  ".pot": "application/vnd.ms-powerpoint",
  ".ppm": "application/x-ppm",
  ".ppt": "application/vnd.ms-powerpoint",
  ".pr": "application/x-pr",
  ".prn": "application/x-prn",
  ".ps": "application/x-ps",
  ".ptn": "application/x-ptn",
  ".r3t": "text/vnd.rn-realtext3d",
  ".ram": "audio/x-pn-realaudio",
  ".rat": "application/rat-file",
  ".rec": "application/vnd.rn-recording",
  ".rgb": "application/x-rgb",
  ".rjt": "application/vnd.rn-realsystem-rjt",
  ".rle": "application/x-rle",
  ".rmf": "application/vnd.adobe.rmf",
  ".rmj": "application/vnd.rn-realsystem-rmj",
  ".rmp": "application/vnd.rn-rn_music_package",
  ".rmvb": "application/vnd.rn-realmedia-vbr",
  ".rnx": "application/vnd.rn-realplayer",
  ".rpm": "audio/x-pn-realaudio-plugin",
  ".rt": "text/vnd.rn-realtext",
  ".rtf": "application/x-rtf",
  ".sam": "application/x-sam",
  ".sdp": "application/sdp",
  ".sit": "application/x-stuffit",
  ".sld": "application/x-sld",
  ".smi": "application/smil",
  ".smk": "application/x-smk",
  ".sol": "text/plain",
  ".spc": "application/x-pkcs7-certificates",
  ".spp": "text/xml",
  ".sst": "application/vnd.ms-pki.certstore",
  ".stm": "text/html",
  ".svg": "text/xml",
  ".tdf": "application/x-tdf",
  ".tga": "application/x-tga",
  ".tif": "application/x-tif",
  ".tld": "text/xml",
  ".torrent": "application/x-bittorrent",
  ".txt": "text/plain",
  ".uls": "text/iuls",
  ".vda": "application/x-vda",
  ".vml": "text/xml",
  ".vsd": "application/vnd.visio",
  ".vss": "application/vnd.visio",
  ".vst": "application/x-vst",
  ".vsx": "application/vnd.visio",
  ".vxml": "text/xml",
  ".wax": "audio/x-ms-wax",
  ".wb2": "application/x-wb2",
  ".wbmp": "image/vnd.wap.wbmp",
  ".wk3": "application/x-wk3",
  ".wkq": "application/x-wkq",
  ".wm": "video/x-ms-wm",
  ".wmd": "application/x-ms-wmd",
  ".wml": "text/vnd.wap.wml",
  ".wmx": "video/x-ms-wmx",
  ".wp6": "application/x-wp6",
  ".wpg": "application/x-wpg",
  ".wq1": "application/x-wq1",
  ".wri": "application/x-wri",
  ".ws": "application/x-ws",
  ".wsc": "text/scriptlet",
  ".wvx": "video/x-ms-wvx",
  ".xdr": "text/xml",
  ".xfdf": "application/vnd.adobe.xfdf",
  ".xls": "application/vnd.ms-excel",
  ".xlw": "application/x-xlw",
  ".xpl": "audio/scpls",
  ".xql": "text/xml",
  ".xsd": "text/xml",
  ".xslt": "text/xml",
  ".x_b": "application/x-x_b",
  ".sisx": "application/vnd.symbian.install",
  ".ipa": "application/vnd.iphone",
  ".xap": "application/x-silverlight-app",
  ".zip": "application/x-zip-compressed"
};
function X() {
  let t = wx.getFileSystemManager(), a = {}, e = [];
  this.append = (i, n) => (a[i] = n, !0), this.appendFile = (i, n, o) => {
    let p = t.readFileSync(n);
    return Object.prototype.toString.call(p).indexOf("ArrayBuffer") < 0 ? !1 : (o || (o = Y(n)), e.push({
      name: i,
      buffer: p,
      fileName: o
    }), !0);
  }, this.getData = () => aa(a, e);
}
function Y(t) {
  let a = t.lastIndexOf("/");
  return t.substr(a + 1);
}
function aa(t, a) {
  let e = "wxmpFormBoundary" + ea(), i = "--" + e, n = i + "--", o = [];
  if (t && Object.prototype.toString.call(t) === "[object Object]")
    for (let s in t)
      o = o.concat(R(i, s, t[s]));
  if (a && Object.prototype.toString.call(a) === "[object Array]")
    for (let s in a) {
      let c = a[s];
      o = o.concat(R(i, c.name, c.buffer, c.fileName));
    }
  let p = [];
  return p.push(...n.toUtf8Bytes()), o = o.concat(p), {
    contentType: "multipart/form-data; boundary=" + e,
    buffer: new Uint8Array(o).buffer
  };
}
function ea() {
  let t = "";
  for (let a = 0; a < 17; a++) {
    let e = parseInt(Math.random() * 62);
    e <= 9 ? t += e : e <= 35 ? t += String.fromCharCode(e + 55) : t += String.fromCharCode(e + 61);
  }
  return t;
}
function R(t, a, e, i) {
  let n = "", o = !!i;
  n += t + `\r
`, n += 'Content-Disposition: form-data; name="' + a + '"', o ? (n += '; filename="' + i + `"\r
`, n += "Content-Type: " + ia(i) + `\r
\r
`) : (n += `\r
\r
`, n += e);
  var p = [];
  if (p.push(...n.toUtf8Bytes()), o) {
    let s = new Uint8Array(e);
    p = p.concat(Array.prototype.slice.call(s));
  }
  return p.push(..."\r".toUtf8Bytes()), p.push(...`
`.toUtf8Bytes()), p;
}
function ia(t) {
  let a = t.lastIndexOf(".");
  return Q[t.substr(a)] || "application/octet-stream";
}
String.prototype.toUtf8Bytes = function() {
  for (var t = this, a = [], e = 0; e < t.length; e++)
    a.push(...t.utf8CodeAt(e)), t.codePointAt(e) > 65535 && e++;
  return a;
};
String.prototype.utf8CodeAt = function(t) {
  var a = this, e = [], i = 0, n = a.charCodeAt(t);
  return n < 128 ? e[i++] = n : n < 2048 ? (e[i++] = n >> 6 | 192, e[i++] = n & 63 | 128) : (n & 64512) === 55296 && t + 1 < a.length && (a.charCodeAt(t + 1) & 64512) === 56320 ? (n = 65536 + ((n & 1023) << 10) + (a.charCodeAt(++t) & 1023), e[i++] = n >> 18 | 240, e[i++] = n >> 12 & 63 | 128, e[i++] = n >> 6 & 63 | 128, e[i++] = n & 63 | 128) : (e[i++] = n >> 12 | 224, e[i++] = n >> 6 & 63 | 128, e[i++] = n & 63 | 128), e;
};
function ta(t) {
  var i;
  const a = (i = window == null ? void 0 : window.envConfig) == null ? void 0 : i.VUE_APP_ICLOUD_UPLOAD_BASE_URL;
  return a || t;
}
function na(t, a) {
  const e = new X();
  for (let n in t)
    e.append(n, t[n]);
  return e.appendFile("file", a), e.getData();
}
function oa(t) {
  const a = t / 1024 / 1024;
  return Math.floor(a);
}
function ua(t, a) {
  return new Promise(async (e, i) => {
    const { account: n, contentType: o, domain: p, fileType: s, fileName: c, userId: l, userType: m, file: d } = a, { token: r, baseURL: u, fileSize: f } = t;
    if (await oa(f) > 5) {
      i({
        data: null,
        code: 500123,
        success: !1,
        msg: "文件大小已超过5MB"
      });
      return;
    }
    const _ = na({
      account: n,
      contentType: o,
      domain: p,
      filetype: s,
      filename: c,
      userid: l,
      usertype: m
    }, d), S = ta(u) + "/asset/v1/file/upload/v1";
    await wx.request({
      url: S,
      data: _.buffer,
      method: "POST",
      header: {
        Authorization: r,
        "Content-Type": _.contentType
      },
      success(h) {
        e(h.data);
      },
      fail(h) {
        i(h);
      }
    });
  });
}
export {
  z as default,
  xa as iCloudAuthorizationFile,
  ra as iCloudConvertFile,
  ca as iCloudDownloadPreviewFile,
  la as iCloudMetaFile,
  da as iCloudProcessingFile,
  ma as iCloudUploadDisposeV3,
  ua as miniUpload
};
//# sourceMappingURL=icloud-upload.esm.js.map
